import React from 'react';
import { QuestionForm } from '@catalogo/ui-americanas-desktop-product-form/src/components/organisms/QuestionForm';
import { Wrapper, Title, SubTitle, Button } from './styled';
import { HasNoQuestionsProps } from '../../../types';

export const HasNoQuestions = (props: HasNoQuestionsProps) => {
  const { productId, product, config, dispatchMetrics, mobile } = props;

  const form = mobile ? (
    <QuestionForm
      className="primary"
      productId={productId}
      config={config}
      product={product}
      dispatchMetrics={dispatchMetrics}
      metricParams={{
        category: 'qna-pdp',
        action: 'fazer-pergunta',
        label: 'produto-sem-qna',
      }}
    >
      fazer pergunta
    </QuestionForm>
  ) : (
    <Button href={`/perguntar/${productId}`}>Fazer pergunta</Button>
  );

  return (
    <Wrapper>
      <Title mobile={mobile}>Esse produto ainda não tem perguntas</Title>
      <SubTitle mobile={mobile}>Aproveite e faça a primeira :)</SubTitle>
      {form}
    </Wrapper>
  );
};
